module.exports = __webpack_public_path__ + "Wing_feathers_DiffuseColor.2a1dd78.basis";